import { render, staticRenderFns } from "./RxToday.vue?vue&type=template&id=6e913f86&scoped=true&"
import script from "./RxToday.vue?vue&type=script&lang=js&"
export * from "./RxToday.vue?vue&type=script&lang=js&"
import style0 from "./RxToday.vue?vue&type=style&index=0&id=6e913f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e913f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VDataTable,VIcon,VRow,VTextField})
